import { Box, Form, Text } from '@domain-group/suit-theme'

import type { ActivityModel } from '@models/types'

import Change from '../Change'
import usePriceListActivity from '../../hooks/usePriceListActivity'

interface PriceListParametersProps {
  activity: ActivityModel,
}

const PriceListParameters = (props: PriceListParametersProps) => {
  const {
    activity,
    activity: { action, parameters },
  } = props

  const { changes } = parameters || {}

  const {
    agenciesReassignedFromPriceListId,
    changeDirection,
    changeKeys,
    changePercentage,
    hideChanges,
    mergedIds,
    nextPriceListId,
    option,
    product,
    reassignedAgencyIds,
    reassignedAgencyProviderIds,
    value,
  } = usePriceListActivity(activity)

  if (!changeKeys.length) return null

  return (
    <Box flexDirection="column">
      {product?.title && (
        <Form.Field label="Product" marginTop="large">
          <Text fontSize="small">{product.title}</Text>
        </Form.Field>
      )}

      {option?.title && (
        <Form.Field label="Option" marginTop="large">
          <Text fontSize="small">{option.title}</Text>
        </Form.Field>
      )}

      {value?.title && (
        <Form.Field label="Value" marginTop="large">
          <Text fontSize="small">{value.title}</Text>
        </Form.Field>
      )}

      {!hideChanges && changeKeys.map(fieldKey => (
        // @ts-expect-error TS18048
        <Change fieldKey={fieldKey} values={changes[fieldKey]} />
      ))}

      {action === 'adjust_prices_by_percentage' && (
        <Form.Field boxProps={{ marginY: 'large' }} label="Prices Adjusted by Percentage">
          <Text fontSize="small" style={{ textTransform: 'capitalize' }}>
            {`${changeDirection} ${changePercentage}%`}
          </Text>
        </Form.Field>
      )}

      {action === 'merge_price_lists' && (
        <Form.Field boxProps={{ marginY: 'large' }} label="Merged Price List IDs">
          <Text fontSize="small">{JSON.stringify(mergedIds)}</Text>
        </Form.Field>
      )}

      {action === 'bulk_reassign_agencies' && (
        <>
          <Form.Field label="Original Price List ID" marginTop="large">
            <Text fontSize="small">{agenciesReassignedFromPriceListId}</Text>
          </Form.Field>

          {nextPriceListId && (
            <Form.Field label="Next Price List ID" marginTop="large">
              <Text fontSize="small">{nextPriceListId}</Text>
            </Form.Field>
          )}

          {reassignedAgencyIds && (
            <Form.Field boxProps={{ marginY: 'large' }} label="Agency IDs">
              <Text fontSize="small">{JSON.stringify(reassignedAgencyIds)}</Text>
            </Form.Field>
          )}

          {!reassignedAgencyIds && (
            <Form.Field boxProps={{ marginY: 'large' }} label="Agency Provider IDs">
              <Text fontSize="small">{JSON.stringify(reassignedAgencyProviderIds)}</Text>
            </Form.Field>
          )}
        </>
      )}
    </Box>
  )
}

export default PriceListParameters
